import { render, staticRenderFns } from "./loadingPopup.vue?vue&type=template&id=29b04158&scoped=true"
import script from "./loadingPopup.vue?vue&type=script&lang=js"
export * from "./loadingPopup.vue?vue&type=script&lang=js"
import style0 from "./loadingPopup.vue?vue&type=style&index=0&id=29b04158&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29b04158",
  null
  
)

export default component.exports